import { ToastAlertTypes, UI } from '@genial/components';
import { ErrorResponse } from '@genial/services';
import * as NB from 'native-base';
import React from 'react';

export const useToastCreator = (toastId: string) => {
  const toast = NB.useToast();

  const showToast = (
    type: ToastAlertTypes.Type,
    title: string,
    description: string,
    options?: NB.IToastProps
  ) => {
    return (
      !toast.isActive(toastId) &&
      toast.show({
        ...options,
        id: toastId,
        placement: 'top',
        render: () => {
          return (
            <UI.ToastAlert
              testId="example-toast"
              onClose={() => toast.close(toastId)}
              type={type}
              title={title}
              description={description}
            />
          );
        },
      })
    );
  };

  const showToastFromError = (error: ErrorResponse | Partial<ErrorResponse>) => {
    const title = error.errorTitle || 'Opa! Algo parece errado.';

    const errorMessage =
      error.errorMessage ||
      'Ocorreu um erro, verifique sua conexão com a internet e tente novamente em instantes.';
    const errorSuggest = error.errorSuggest || '';

    const description = `${errorMessage} ${errorSuggest}`;
    showToast('error', title, description);
  };

  return { showToast, showToastFromError };
};
